module.exports = __webpack_public_path__ + "img/pos_ma_giam_gia.e4e32232.png";